import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20e3d3fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support" }
const _hoisted_2 = {
  key: 0,
  class: "support_preloader"
}
const _hoisted_3 = {
  key: 1,
  class: "support_content"
}
const _hoisted_4 = ["data-categoryId", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "support_wrapper"
}
const _hoisted_6 = { class: "support_categoryTitle" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3678_12403)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L7.70711 11.7071C7.07714 11.0771 7.52331 10 8.41421 10H15.5858C16.4767 10 16.9229 11.0771 16.2929 11.7071L12.7071 15.2929Z",
      fill: "#B4B8BB"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3678_12403" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3678_12409)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.7071 8.70711C12.3166 8.31658 11.6834 8.31658 11.2929 8.70711L7.70711 12.2929C7.07714 12.9229 7.52331 14 8.41421 14H15.5858C16.4767 14 16.9229 12.9229 16.2929 12.2929L12.7071 8.70711Z",
      fill: "#3C92FE"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3678_12409" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "matrix(1 0 0 -1 0 24)"
      })
    ])
  ])
], -1))
const _hoisted_10 = { class: "support_categoryTitle" }
const _hoisted_11 = {
  key: 1,
  class: "support_empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_preloader = _resolveComponent("as-preloader")!
  const _component_support_description = _resolveComponent("support-description")!
  const _component_ac_expansion_panel = _resolveComponent("ac-expansion-panel")!
  const _component_ac_expansion_panels = _resolveComponent("ac-expansion-panels")!
  const _component_ac_empty = _resolveComponent("ac-empty")!
  const _component_as_tech_question = _resolveComponent("as-tech-question")!
  const _component_ac_modal = _resolveComponent("ac-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_as_preloader)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(['support_column', '-title', `${_ctx.selectedCategory ? '-selected' : ''}`])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["support_categories", {
            '-not-selected': !_ctx.isSelectedCategory
          }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `question-${i}`,
                    class: _normalizeClass([
              'support_category',
              _ctx.isActiveCategory(category.id) ? '-active' : ''
            ]),
                    "data-categoryId": category.id,
                    onClick: ($event: any) => (_ctx.setContent(category.id))
                  }, _toDisplayString(category.title), 11, _hoisted_4))
                }), 128))
              ], 2)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(['support_column', '-description', `${_ctx.selectedCategory ? '-selected' : ''}`])
            }, [
              (_ctx.selectedCategory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.showSelectionStream)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.selectedCategory.title), 1),
                          (_ctx.userCourseStreams.length)
                            ? (_openBlock(), _createBlock(_component_ac_expansion_panels, {
                                key: 0,
                                class: "support_panels"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCourseStreams, (userCourseStream, key) => {
                                    return (_openBlock(), _createBlock(_component_ac_expansion_panel, {
                                      key: `ac-expansion-panel-${key}`,
                                      "data-streamId": userCourseStream.stream.id,
                                      class: "support_panel panel",
                                      "custom-toggle": "",
                                      "is-open": userCourseStream.stream.id === _ctx.selectedStreamId,
                                      "is-close": userCourseStream.stream.id !== _ctx.selectedStreamId,
                                      onOpen: ($event: any) => (_ctx.setStreamId(userCourseStream.stream.id)),
                                      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setStreamId(null)))
                                    }, {
                                      title: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "panel_title",
                                          innerHTML: userCourseStream.course.title
                                        }, null, 8, _hoisted_7)
                                      ]),
                                      "icon-expand": _withCtx(() => [
                                        _hoisted_8
                                      ]),
                                      "icon-collapse": _withCtx(() => [
                                        _hoisted_9
                                      ]),
                                      text: _withCtx(() => [
                                        _createVNode(_component_support_description, {
                                          category: _ctx.selectedCategory,
                                          onAutoResolve: _ctx.autoResolveHandler,
                                          onShowTech: _ctx.showTech
                                        }, null, 8, ["category", "onAutoResolve", "onShowTech"])
                                      ]),
                                      _: 2
                                    }, 1032, ["data-streamId", "is-open", "is-close", "onOpen"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_ac_empty, {
                                key: 1,
                                "show-button": false
                              }))
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.selectedCategory.title), 1),
                          _createVNode(_component_support_description, {
                            category: _ctx.selectedCategory,
                            onAutoResolve: _ctx.autoResolveHandler,
                            onShowTech: _ctx.showTech,
                            class: "support_categoryDescription"
                          }, null, 8, ["category", "onAutoResolve", "onShowTech"])
                        ], 64))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('selectTopicLeft')), 1))
            ], 2)
          ]))
    ]),
    _createVNode(_component_ac_modal, {
      modelValue: _ctx.showTechQuestion,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showTechQuestion) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_tech_question, {
          "stream-id": _ctx.selectedStreamId,
          "category-id": _ctx.selectedId,
          class: "support_modal",
          onSubmit: _ctx.onSubmitTechQuestion,
          "btn-close": "",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTechQuestion = false))
        }, null, 8, ["stream-id", "category-id", "onSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}